import match from 'conditional-expression'
import { useParams } from 'react-router'

import MyStakesTab from './MyStakesTab'
import RwaTab from './RwaTab'
import { StakingContextProvider } from './StakingContext'

const Staking = () => {
  const { category = 'shared' } = useParams<{ category?: string }>()
  return (
    <StakingContextProvider>
      {match(category)
        .equals('shared')
        .then(<RwaTab />)
        .equals('my-stakes')
        .then(<MyStakesTab />)
        .else(null)}
    </StakingContextProvider>
  )
}

export default Staking
